import React, { Component } from 'react'
import { translate } from '../utils/useful'
import ReactDOM from "react-dom"; // Import ReactDOM
import ReactDOMServer from 'react-dom/server';

import { checkActiveStyles, createNotebookImage, createSpanWithStyle, findRangeSelectedSpans, getStyleObject, resizeArrows, textEffectsList } from '../variables/notebook';
import EmptyColumn from '../components/pageBuilder2/components/EmptyColumn';
import { ResizableElement } from '../components/ResizableElement';
import { nanoid } from 'nanoid';
// import ReactHtmlParser, { convertNodeToElement, processNodes } from 'react-html-parser';
import { customAlphabet } from 'nanoid'
import { CodeBlock, dracula } from 'react-code-blocks';


export default class Notebooksheet extends Component {
    state = {
        // id: this.props.id ?? nanoid(),
        show: false,
        showPlaceholder: false
    };
    DOMlessState = {};

    componentDidMount() {


        setTimeout(() => {
            this.setState({ show: true }, () => {



                this.init()

                const config = { attributes: true, childList: true, subtree: true, characterData: true, characterDataOldValue: true };

                this.observer = new MutationObserver(this.observeChanged)
                this.observer.observe(this.editor, config);


                // this.editor.addEventListener("DOMCharacterDataModified", this.onCharacterModified);


            })
        }, 50);


    }


    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect()
        }
    }




    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data) {
            // console.log('herrrreeeeeUpdate')
            // this.init()
        }
        if (this.props.currentPage != prevProps.currentPage) {
            this.init()
        }

    }


    observeChanged = (e) => {

        // console.log("onChange")
        let content = this.getContent()

        if (this.props.changeValue) {
            this.props.changeValue(content)
        }
    }



    init() {

        // console.log("init")
        const firstChild = this.editor?.firstChild;


        // console.log("this.props.data")
        // console.log(this.props.data)

        if (this.editor && !this.props.isDragging) {
            if (this.props.data) {

                // console.log(ReactHtmlParser(this.props.data))
                // console.log(ReactHtmlParser(this.props.data))
                // console.log(new DOMParser().parseFromString(this.props.data, "text/html").querySelector('body').innerHTML)
                // console.log(processNodes(this.props.data))
                this.setState({ showPlaceholder: false })

                this.editor.innerHTML = new DOMParser().parseFromString(this.props.data, "text/html").querySelector('body').innerHTML
            } else {
                this.setState({ showPlaceholder: true })
                this.editor.innerHTML = new DOMParser().parseFromString("<span>&#8203;</span>", "text/html").querySelector('body').innerHTML
            }

            setTimeout(() => {
                const range = document.createRange();

                if (firstChild) {
                    range.setStart(firstChild, 0);
                    range.setEnd(firstChild, 0);

                    const selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }, 10);
        }


    }



    // onCharacterModified = (e, isClick) => {
    //     // e.preventDefault()

    //     // console.log(e)
    //     setTimeout(() => {

    //         // console.log(e)

    //         let selection = document.getSelection()
    //         // console.log(selection)
    //         let node = selection.anchorNode
    //         let offset = selection.focusOffset

    //         console.log("node")
    //         console.log(node)

    //         return
    //         if (node) {


    //             let currentVariable
    //             if (node.parentNode.classList.contains('smart-variable')) {
    //                 currentVariable = node.parentNode.id
    //             }



    //             let text = String(node.textContent)
    //             let range = document.createRange()



    //             if (currentVariable) {
    //                 if ((e.prevValue !== e.newValue)) {

    //                     if ((text.startsWith('@') && text.endsWith('@'))) {

    //                         // let oldNode = node
    //                         let textNode = document.createTextNode(e.prevValue)
    //                         node.replaceWith(textNode)
    //                         let oldNode = textNode
    //                         // oldNode.nodeValue = 'RWD'
    //                         node = document.createTextNode('@')
    //                         oldNode.parentNode.parentNode.insertBefore(node, oldNode.parentNode.nextSibling);
    //                         document.getSelection().removeAllRanges()
    //                         range.setStart(node, 1)
    //                         range.setEnd(node, 1)
    //                         document.getSelection().addRange(range)
    //                         text = String(node.textContent)

    //                     } else {

    //                         if (text.charCodeAt(text.length - 1) == 32 || text.charCodeAt(text.length - 1) == 160) {
    //                             // console.log("DLJDLDKW")
    //                             // console.log(node.parentNode)
    //                             // node.parentNode.nodeValue = e.prevValue
    //                             // console.log(node)
    //                             // node.nodeValue = "test" 
    //                             // node.replaceWith(document.createTextNode('test'))
    //                             let oldNode = node
    //                             node = document.createTextNode(e.prevValue)
    //                             oldNode.replaceWith(node)

    //                             let nextSibling = node.parentNode.nextSibling
    //                             if (nextSibling && nextSibling.nodeValue && nextSibling.nodeValue != '') {
    //                                 node = node.parentNode.nextSibling
    //                                 // console.log(node)
    //                                 // console.log("NEXT")
    //                             } else {
    //                                 let textNode = document.createTextNode(' ');
    //                                 node.parentNode.parentNode.insertBefore(textNode, node.parentNode.nextSibling);
    //                                 node = textNode
    //                                 // console.log("CREATE")
    //                             }
    //                             document.getSelection().removeAllRanges()
    //                             if (!node.length == 0) {
    //                                 node.innerHTML = ' '
    //                             }
    //                             range.setStart(node, 1)
    //                             range.setEnd(node, 1)
    //                             document.getSelection().addRange(range)
    //                             text = String(node.textContent)

    //                         } else {
    //                             let textNode = document.createTextNode(text);
    //                             node.parentNode.replaceWith(textNode)
    //                             node = textNode
    //                             document.getSelection().removeAllRanges()
    //                             // console.log(text)
    //                             // console.log(text.length)
    //                             // console.log(offset)
    //                             range.setStart(node, offset)
    //                             range.setEnd(node, offset)
    //                             document.getSelection().addRange(range)
    //                             let variables = this.state.variables
    //                             delete variables[currentVariable]
    //                             // console.log(variables)
    //                         }
    //                     }
    //                 }
    //             }


    //             // console.log(node)
    //             // let nodeText = 
    //             let lastTextArray = text.slice(0, selection.focusOffset)
    //             lastTextArray = lastTextArray.split(' ')
    //             // console.log(lastText)
    //             // lastText = lastText[lastText.length - 1]
    //             // console.log(node)
    //             // console.log(lastText+'!!!')
    //             // console.log(lastText.split(''))
    //             // console.log(" ".charCodeAt(0))
    //             // console.log("&nbsp;".charCodeAt(0))
    //             // console.log("\s".charCodeAt(0))
    //             // console.log(" ".charCodeAt(0))

    //             lastTextArray.forEach(lastText => {

    //                 // console.log(lastText)

    //                 let focusOffset = selection.focusOffset




    //                 if (lastText.charAt(0) != '@') {
    //                     // console.log(lastText)
    //                     lastText = lastText.replace(/ /g, '');
    //                     lastText = lastText.replace(/ /g, '')
    //                 }

    //                 if (node.length >= selection.focusOffset - lastText.length) {
    //                     range.setStart(node, selection.focusOffset - lastText.length);
    //                 }
    //                 if (node.length >= selection.focusOffset) {
    //                     range.setEnd(node, selection.focusOffset)
    //                 }


    //                 // lastText = lastText.replace("&nbsp;","")
    //                 // lastText = lastText.replace(" ","")
    //                 // console.log(lastText)
    //                 if (lastText.charAt(0) == '@') {

    //                     if (!this.state.showList) {
    //                         this.openList()
    //                         // this.setState({ showList: true })
    //                     }

    //                     // if (lastText.length == 1 && !isClick) {
    //                     //     console.log("RANGE")
    //                     //     document.getSelection().removeAllRanges()
    //                     //     document.getSelection().addRange(range)
    //                     //     // console.log("BLUEEEE")
    //                     //     this.changeAttribute('foreColor', "007aff")
    //                     //     let parent = document.getSelection().anchorNode.parentNode
    //                     //     // parent.classList.add('cursor-pointer')
    //                     //     parent.classList.add('smart-variable')

    //                     //     // console.log(parent)
    //                     //     // window.getSelection().focusNode.addClass('cursor-pointer')

    //                     // }

    //                     let lastChar = lastText.charAt(lastText.length - 1)


    //                     if (node.length >= selection.focusOffset) {
    //                         // console.log('###')
    //                         // console.log(selection.focusOffset)
    //                         range.setStart(node, selection.focusOffset)
    //                         range.setEnd(node, selection.focusOffset)
    //                         document.getSelection().addRange(range)
    //                         // document.getSelection().removeAllRanges()

    //                     }

    //                     if ((lastChar == ' ' || lastChar == " ") && !isClick) {
    //                         // console.log("CLOSE")

    //                         range.setStart(node, selection.focusOffset)
    //                         range.setEnd(node, selection.focusOffset)
    //                         document.getSelection().addRange(range)

    //                         // this.changeAttribute('delete', "")
    //                         // this.changeAttribute('insertHTML', "<span> </span>")
    //                         setTimeout(() => {
    //                             // this.setState({ showList: false })
    //                             this.closeList()
    //                         }, 50);
    //                     }

    //                     if (node.textContent == '@') {
    //                         // console.log(selection)
    //                         document.getSelection().removeAllRanges()
    //                         range.setStart(node, 1)
    //                         range.setEnd(node, 1)
    //                         document.getSelection().addRange(range)
    //                         // range.setStart(node, 1)
    //                         // range.setEnd(node, 1)
    //                         // document.getSelection().addRange(range)

    //                     }







    //                     // let newNode = document.createElement("span")
    //                     // newNode.innerHTML = '&nbsp;'
    //                     // this.editor.appendChild(newNode)

    //                     // document.getSelection().removeAllRanges()

    //                     // document.insertBefore(newNode,this.editor)
    //                     // console.log(focusOffset)
    //                     // setTimeout(() => {
    //                     // console.log(this.editor.childNodes)
    //                     // let nNode = this.editor.childNodes[this.editor.childNodes-1]
    //                     // console.log(this.editor.childNodes[this.editor.childNodes-1])
    //                     // console.log(nNode)
    //                     // setTimeout(() => {
    //                     // let nNode = this.findNextNode(node)
    //                     // console.log(nNode)
    //                     // if (nNode) {
    //                     //     range.setStart(nNode, 1);
    //                     //     range.setEnd(nNode, 1)
    //                     //     document.getSelection().addRange(range)
    //                     // }

    //                     // range.collapse(true)
    //                     // }, 100);

    //                     // document.getSelection().removeAllRanges()

    //                     // this.editor.focus()
    //                     // console.log(document.getSelection().focusNode)
    //                     // document.execCommand('foreColor', true, '#abc')
    //                     // document.execCommand("defaultParagraphSeparator", false, "p");

    //                     // }, 50);

    //                     // console.log(node.nextSibling)
    //                     // document.getSelection().empty()

    //                     // selection.empty()
    //                     // range.deleteContents()
    //                 } else {
    //                     // console.log("HEEEHEHE")
    //                     if (this.state.showList) {
    //                         this.closeList()
    //                         // this.setState({ showList: false })
    //                     }
    //                     // let parent = document.getSelection().anchorNode.parentNode
    //                     // console.log("HWERE")
    //                     // console.log(lastText.charAt(0))
    //                     // if (lastText.charAt(0) != '@' && !isClick) {
    //                     //     console.log("removeFormat")
    //                     //     document.execCommand("removeFormat", false, "foreColor");
    //                     // }
    //                     // console.log(document.getSelection())
    //                     // if (parent && parent.classList.contains('smart-variable')) {
    //                     //     this.changeAttribute('foreColor', "#890")
    //                     //     this.changeAttribute('delete', "")

    //                     //     document.getSelection().removeAllRanges()


    //                     // }
    //                 }

    //             });
    //             // range.clea

    //             // ;

    //             // selection.addRange(range)

    //             // this.editor.normalize()
    //             // console.log(this.editor)
    //             // console.log(document.getSelection())

    //             var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    //             var regex = new RegExp(expression);

    //             var t = 'www.google.com';
    //             // if (t.match(regex)) {
    //             //     console.log("Successful match");
    //             // } else {
    //             //     console.log("No match");
    //             // }

    //             // if(e.newValue)
    //             // if()


    //         }
    //     }, 20);

    // }

    insertText = (text) => {
        if (this.editor) {
            this.editor.focus()
            let selection = window.getSelection();
            let range = selection.getRangeAt(0);
            range.deleteContents();
            let node = document.createTextNode(text);
            range.insertNode(node);

            // for (let position = 0; position != text.length; position++) {
            selection.modify("move", "right", "character");
            // };
        }

    }


    getContent = () => {


        // console.log(this.editor.innerHTML)
        // console.log(String(this.editor.innerHTML))
        let text = this.editor.innerText
        if (!text || text == '' || text == '​' || text == "\u200B" || text == '' || text == '\n') {
            console.log("here")
            this.setState({ showPlaceholder: true })
        } else {
            if (this.state.showPlaceholder) {
                this.setState({ showPlaceholder: false })
            }
        }

        return this.editor.innerHTML
    }


    handleInput = (e) => {
        const div = this.editor;
        // console.log("handleInput")
        // console.log(e)

        // console.log(div)
        if (div) {
            const tags = ["b", "i", "u"];
            const hasTags = div.querySelectorAll("b, i, u") !== null;
            hasTags &&
                tags.forEach((tag) => {
                    const elements = div.getElementsByTagName(tag);
                    for (let i = elements.length - 1; i >= 0; i--) {
                        const text = document.createTextNode("");
                        elements[i].replaceWith(text);
                    }
                });
        }
    };
    // titleValue = (e) => {
    //     this.setState({ titleValue: e.target.value })
    // }
    preventDefaultKeys = ["b", "i", "Enter", "u"];


    getActiveStyle = (e) => {
        const selection = window.getSelection();
        const rangeCount = selection.rangeCount;
        if (!selection || rangeCount === 0) return
        const range = selection?.getRangeAt(0);
        const selectedText = range?.toString();
        const selectedSpans = findRangeSelectedSpans(range, this.editor)
        const currentStyles = checkActiveStyles(selectedSpans[0]);
        // console.log("currentStyles, ", currentStyles)
        this.DOMlessState = {
            ...this.DOMlessState,
            activeStylesList: currentStyles
        }

        // console.log(currentStyles)
        if (this.props.updateTextEffectsStyleStatus) {
            this.props.updateTextEffectsStyleStatus(currentStyles);
        }
    }
    draggingImage = null; // Store the dragging image element

    handleDragStart = (event) => {
        this.draggingImage = event.target;
        event.dataTransfer.setData("text/plain", event.target.id);
        event.dataTransfer.setDragImage(event.target, 0, 0); // Hide the default drag image
        this.draggingImage.style.pointerEvents = "none"; // Prevent the image from affecting the drop position
    };

    handleDragEnd = () => {
        if (this.draggingImage) {
            this.draggingImage.style.pointerEvents = "auto"; // Restore interactivity after dragging ends
            this.draggingImage = null; // Reset the dragging image variable
        }
    };

    handleOnDrop = (event) => {
        event.persist();
        event.preventDefault();
        console.log("HERE");
        const dataTransfer = event.dataTransfer;
        if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
            const file = dataTransfer.files[0];
            if (file.type.startsWith("image/")) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const imgSrc = e.target.result;
                    const x = event.clientX; // Store the values before using them in the callback
                    const y = event.clientY;
                    this.insertImage(imgSrc, x, y);
                };
                reader.readAsDataURL(file);
            }
        }
    }

    insertImage = (src, x, y) => {
        const { x: relativeX, y: relativeY } = this.calculateDropPosition(x, y);
        console.log(relativeX, relativeY);
        const img = createNotebookImage(src);
        const ResizableImg = <ResizableElement parentWrapperStyle={{ position: "absolute", width: '90%', height: 200, }} resizeArrows={this.resizeArrows}
            sharedClassName={'resizer'}
            sharedStyles={{}}
            sideDistancePX={-2}
            activeClassName={'noteBookImageCursorActive'}>{img}</ResizableElement>;
        const selection = window.getSelection();
        if (selection.rangeCount === 0) {
            return;
        }
        try {
            // Create a new range at the desired offset
            const range = selection.getRangeAt(0);
            const reactNode = document.createElement('div');
            ReactDOM.render(ResizableImg, reactNode);
            const span = findRangeSelectedSpans(range, this.editor);
            console.log(span)
            if (span[0]) {
                span.at(0).replaceWith(span[0], reactNode);
            }
            else {
                range.insertNode(reactNode);

            }
        } catch (error) {
            console.log(error)
        }
    };

    calculateDropPosition = (clientX, clientY) => {
        const imageDiv = this.editor;
        if (!imageDiv) return { x: 0, y: 0 };

        const parentRect = imageDiv.getBoundingClientRect();

        // Calculate the position of the drop relative to the parent's top left corner
        const dropX = clientX - parentRect.left;
        const dropY = clientY - parentRect.top;

        return { x: dropX, y: dropY };
    };
    handleDocumentClick = (event) => {
        const clickTarget = event.target;
        console.log();
        if (clickTarget.className === 'keep_caret_position') {
            setTimeout(() => {
                console.log("detect ")
            }, 500);
        }
        const editorElement = this.editor;

        // Check if the click target is within the editor or one of its descendants
        // if (editorElement && !editorElement.contains(clickTarget)) {
        //     const range = document.createRange();
        //     range.selectNodeContents(editorElement);
        //     range.collapse(false); // Set to the end of the range
        //     const selection = window.getSelection();
        //     selection.removeAllRanges();
        //     selection.addRange(range);
        //     editorElement.focus();
        // }
    };



    // onKeyDown = (e) => {

    //     // console.log("onKeyDown")
    //     if (this.preventDefaultKeys.includes(e.key) && e.key === "Control") {
    //         e.preventDefault();
    //     }
    //     if (e.key === "Backspace") {
    //         // let selection = document.getSelection()
    //         // // console.log(selection)
    //         // let node = selection.anchorNode
    //         // let text = node?.textContent
    //         // let offset = selection.focusOffset
    //         // console.log(typeof node)
    //         // console.log(node)
    //         // console.log(node.parentNode)

    //         // if( text == '' || text == ' ' || text == " " || text == '​' || text == "\u200B"){
    //         //     console.log('Empty')
    //         //     // setTimeout(() => {
    //         //         node.remove()
    //         //     // }, 10);

    //         // }

    //     }
    //     if (e.key === "Enter") {
    //         e.preventDefault();
    //         try {
    //             const activeStylesList = [...this.DOMlessState.activeStylesList]
    //             const activeStyles = textEffectsList.filter(effect => activeStylesList.includes(effect.styleName)).map(effect => {
    //                 const { effectType, styleName } = effect;
    //                 return {
    //                     effectType,
    //                     styleName
    //                 }
    //             });
    //             const brElement = document.createElement("br");
    //             console.log("after br")
    //             const toAddStylesObject = {};
    //             for (const activeStyle of activeStyles) {
    //                 toAddStylesObject[activeStyle.styleName] = activeStyle.effectType;
    //             }
    //             const selection = window.getSelection();
    //             const range = selection.getRangeAt(0);
    //             const selectedSpans = findRangeSelectedSpans(range, this.editor);
    //             const singleSpan = selectedSpans[0];
    //             const singleSpanText = singleSpan?.textContent
    //             const span = createSpanWithStyle(toAddStylesObject, null);
    //             span.innerHTML = "\u200B";
    //             range.deleteContents();
    //             if (!singleSpan) {
    //                 console.log("NOSPAN")
    //                 range.insertNode(span);
    //             } else {
    //                 console.log("END OF SPAN")
    //                 if (singleSpanText.length === range.endOffset) {
    //                     singleSpan.replaceWith(
    //                         singleSpan,
    //                         brElement,
    //                         span,

    //                     )
    //                     const newRange = document.createRange();
    //                     newRange.selectNodeContents(span);
    //                     newRange.collapse(false); // To move the caret to the end of the span
    //                     selection.removeAllRanges();
    //                     selection.addRange(newRange);
    //                 } else {
    //                     console.log("MIDDLE OF SPAN")
    //                     const caretOffset = range.endOffset;
    //                     const beforeCaret = singleSpanText.substring(0, caretOffset);
    //                     const afterCaret = singleSpanText.substring(caretOffset);
    //                     const beforeTextSpan = createSpanWithStyle(
    //                         { ...getStyleObject(singleSpan.style) },
    //                         beforeCaret
    //                     );
    //                     const afterTextSpan = createSpanWithStyle(
    //                         { ...getStyleObject(singleSpan.style) },
    //                         afterCaret
    //                     );
    //                     singleSpan.replaceWith(beforeTextSpan, brElement, afterTextSpan);
    //                     const newRange = document.createRange();
    //                     newRange.selectNodeContents(afterTextSpan);
    //                     newRange.collapse(true); // To move the caret to the beginning of the span
    //                     const selection = window.getSelection();
    //                     selection.removeAllRanges();
    //                     selection.addRange(newRange);
    //                 }
    //             }


    //             // Move the cursor after the <span> element

    //         } catch (error) {
    //             console.log(error)
    //         }


    //     }
    // }



    onKeyDownCode = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            try {
                const activeStylesList = [...this.DOMlessState.activeStylesList]
                const activeStyles = textEffectsList.filter(effect => activeStylesList.includes(effect.styleName)).map(effect => {
                    const { effectType, styleName } = effect;
                    return {
                        effectType,
                        styleName
                    }
                });
                const brElement = document.createElement("br");
                console.log("after br")
                const toAddStylesObject = {};
                for (const activeStyle of activeStyles) {
                    toAddStylesObject[activeStyle.styleName] = activeStyle.effectType;
                }
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                const selectedSpans = findRangeSelectedSpans(range, this.editor);
                const singleSpan = selectedSpans[0];
                const singleSpanText = singleSpan?.textContent
                const span = createSpanWithStyle(toAddStylesObject, null);
                span.innerHTML = "\u200B";
                range.deleteContents();
                if (!singleSpan) {
                    console.log("NOSPAN")
                    range.insertNode(span);
                } else {
                    console.log("END OF SPAN")
                    if (singleSpanText.length === range.endOffset) {
                        singleSpan.replaceWith(
                            singleSpan,
                            brElement,
                            span,

                        )
                        const newRange = document.createRange();
                        newRange.selectNodeContents(span);
                        newRange.collapse(false); // To move the caret to the end of the span
                        selection.removeAllRanges();
                        selection.addRange(newRange);
                    } else {
                        console.log("MIDDLE OF SPAN")
                        const caretOffset = range.endOffset;
                        const beforeCaret = singleSpanText.substring(0, caretOffset);
                        const afterCaret = singleSpanText.substring(caretOffset);
                        const beforeTextSpan = createSpanWithStyle(
                            { ...getStyleObject(singleSpan.style) },
                            beforeCaret
                        );
                        const afterTextSpan = createSpanWithStyle(
                            { ...getStyleObject(singleSpan.style) },
                            afterCaret
                        );
                        singleSpan.replaceWith(beforeTextSpan, brElement, afterTextSpan);
                        const newRange = document.createRange();
                        newRange.selectNodeContents(afterTextSpan);
                        newRange.collapse(true); // To move the caret to the beginning of the span
                        const selection = window.getSelection();
                        selection.removeAllRanges();
                        selection.addRange(newRange);
                    }
                }

                const textBeforeCursor = range.startContainer.textContent.slice(0, range.startOffset);
                const codeRegex = /^\/\/code\/\/(\w+)/g;
                const codeEndRegex = /^\/\/codeend$/g;

                // Check if the user typed "//code"
                const matches = textBeforeCursor.match(codeRegex);
                if (matches) {
                    const language = matches[1];
                    const codeContent = '// Insert your code here\n';

                    // Render the code block with syntax highlighting
                    const codeBlock = (
                        <CodeBlock
                            text={codeContent}
                            language={'Python'}
                            showLineNumbers={true} // Set to true if you want line numbers
                            theme={dracula} // Use the desired code highlighting theme
                            wrapLines={true} // Set to false if you don't want line wrapping
                            customStyle={{ fontSize: '14px' }} // Customize the font size as needed
                            className={`${language}-code-block`}
                            codeBlock
                        />
                    );

                    // Insert the code block into your editor
                    const codeBlockNode = document.createElement('div');
                    ReactDOM.render(codeBlock, codeBlockNode);
                    range.startContainer.parentElement.insertBefore(codeBlockNode, range.startContainer.nextSibling);

                    // Move the cursor inside the code block
                    const newRange = document.createRange();
                    newRange.selectNodeContents(codeBlockNode);
                    newRange.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(newRange);
                }

                // Check if the user typed "//codeend"
                if (textBeforeCursor.match(codeEndRegex)) {
                    // Close the code block
                    const codeBlock = document.createElement('div');
                    codeBlock.className = 'code-block';
                    codeBlock.textContent = '//codeend';
                    range.startContainer.parentElement.insertBefore(codeBlock, range.startContainer.nextSibling);
                    const newRange = document.createRange();
                    newRange.setStartAfter(codeBlock);
                    newRange.setEndAfter(codeBlock);
                    selection.removeAllRanges();
                    selection.addRange(newRange);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };


    onKeyDown = (e) => {
        if (e.key === 'Enter' && !this.state.inCode) {
            e.preventDefault();
            try {
                const activeStylesList = [...this.DOMlessState.activeStylesList];
                const activeStyles = textEffectsList.filter((effect) =>
                    activeStylesList.includes(effect.styleName)
                ).map((effect) => {
                    const { effectType, styleName } = effect;
                    return {
                        effectType,
                        styleName,
                    };
                });

                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                const selectedSpans = findRangeSelectedSpans(range, this.editor);
                const singleSpan = selectedSpans[0];
                const singleSpanText = singleSpan?.textContent;
                const brElement = document.createElement('br');
                const span = createSpanWithStyle(activeStyles, null);
                span.innerHTML = '\u200B';

                range.deleteContents();

                if (!singleSpan) {
                    range.insertNode(span);
                } else {
                    if (singleSpanText.length === range.endOffset) {
                        singleSpan.replaceWith(singleSpan, brElement, span);
                        const newRange = document.createRange();
                        newRange.selectNodeContents(span);
                        newRange.collapse(false);
                        selection.removeAllRanges();
                        selection.addRange(newRange);
                    } else {
                        const caretOffset = range.endOffset;
                        const beforeCaret = singleSpanText.substring(0, caretOffset);
                        const afterCaret = singleSpanText.substring(caretOffset);
                        const beforeTextSpan = createSpanWithStyle(
                            { ...getStyleObject(singleSpan.style) },
                            beforeCaret
                        );
                        const afterTextSpan = createSpanWithStyle(
                            { ...getStyleObject(singleSpan.style) },
                            afterCaret
                        );
                        singleSpan.replaceWith(beforeTextSpan, brElement, afterTextSpan);
                        const newRange = document.createRange();
                        newRange.selectNodeContents(afterTextSpan);
                        newRange.collapse(true);
                        selection.removeAllRanges();
                        selection.addRange(newRange);
                    }
                }

                const textBeforeCursor = range.startContainer.innerText;
                const lines = textBeforeCursor.split('\n');
                const lastLine = lines[lines.length - 2].trim();

                const codePrefix = '//code';

                // Check if the user typed "//code//<language>"
                if (lastLine.includes(codePrefix) && !this.state.inCode) {
                    console.log('hiiiiiiiiii', lastLine)
                    let newid = customAlphabet('abcdefghijklmnopqrstuvwxyz', 10)()
                    const language = lastLine.substring(codePrefix.length + 3) ?? "js";
                    const codeBlock = document.createElement('div');
                    codeBlock.className = `code-block ${language}-code-block`;
                    codeBlock.id = newid
                    codeBlock.innerHTML = '// Insert your code here';
                    range.insertNode(codeBlock);


                    const newRange = document.createRange();
                    newRange.setStart(codeBlock, 1);
                    newRange.setEnd(codeBlock, 1);
                    selection.removeAllRanges();
                    selection.addRange(newRange);
                    this.setState({ inCode: newid })
                }
            } catch (error) {
                console.log(error);
            }
        }
        else if (e.key === 'Enter' && this.state.inCode) {
            const selection = window.getSelection();
            const range = selection.getRangeAt(0);
            const textBeforeCursor = range.startContainer.data;
            // const lines = textBeforeCursor.split('\n');
            // const lastLine = lines[lines.length - 2].trim();

            const codePrefixEnd = '//endcode';
            if (textBeforeCursor.includes(codePrefixEnd)) {
                this.setState({ inCode: false }, () => { })
            }
            // else{
            //     let codeBlock = document.getElementById(this.state.inCode)
            //     codeBlock.innerHTML = codeBlock.innerHTML + "<br/>"
            //     return
            // }

        }
    };



    onPaste = (e) => {

        e.preventDefault();

        if (!this.state.rId) {
            const open = new RegExp('<', 'gi');
            const close = new RegExp('>', 'gi');
            const text = (e.originalEvent || e).clipboardData
                .getData('text/plain')
                .replace(open, '&lt')
                .replace(close, '&gt');
            document.execCommand('insertHTML', false, text)


        } else {
            let text = (e.originalEvent || e).clipboardData
                .getData('text/plain')
            // .replace(open, '&lt')
            // .replace(close, '&gt');

            console.log(text)
            text = text.replace('<!DOCTYPE html><meta charset="UTF-8">', '')

            const regex1 = /"rem-([^"]*)"/g

            let found = text.match(regex1);

            // console.log(found)

            // this.setState({ rId: null }, () => {
            // })

            if (Array.isArray(found)) {
                found.forEach(element => {
                    let newid = customAlphabet('abcdefghijklmnopqrstuvwxyz', 10)()
                    let id = element.replace('"rem-', '').replace('"', '')

                    let reg = new RegExp(id, 'g')
                    // console.log("id")

                    // console.log(id)
                    // console.log(newid)

                    text = text.replace(reg, newid)


                    setTimeout(() => {

                        let but = document.querySelector('#rem-' + newid)
                        // console.log(but)
                        let typables = document.querySelectorAll('.typable')
                        // console.log(but)
                        if (but) {
                            but.onclick = () => this.removeFunction(newid)
                        }

                        let eq = document.querySelector("#" + newid)

                        if (eq) {
                            eq.addEventListener('contextmenu', (e) => {
                                // alert("You've tried to open context menu"); //here you draw your own menu
                                e.preventDefault();
                                this.rightClickFunction(newid, e)
                            }, false);

                        }

                        if (typables) {
                            typables.forEach(typable => {
                                typable.onclick = (e) => this.doFocus(e, newid, typable)
                            });
                        }

                    }, 200);

                });

            }


            const selection = window.getSelection();
            if (!selection.rangeCount) return false;
            selection.deleteFromDocument();
            var doc = new DOMParser().parseFromString(text, "text/html");
            // console.log(doc.querySelector('body'))
            // console.log(doc.querySelector('body').firstChild)

            selection.getRangeAt(0).insertNode(doc.querySelector('body').firstChild)
        }
        // this.setState({ rId: null })


    }

    // onChange=()=>{
    //     console.log("onChange")
    //     if(this.props.changeValue){
    //         let content = this.getContent()
    //         this.props.changeValue(content)
    //     }
    // }



    render() {

        let styleInfo = this.props.header?.information?.style
        // console.log('DOMlessState',this.state.DOMlessState)
        return (
            // <div className="h-100 flexcc" style={{ backgroundColor: "#E5E5EA", overflowY: "auto" }} >
            <div className="h-100  w-100 position-relative d-flex flex-column" style={{alignItems:this.props.justifyContent, padding: this.props.hasPadding ? '7px 0px' : null }} >
                {/* <div className="m-5 sc-gray br-10" style={{ backgroundColor: "#fff", width: "500px", height: "700px", overflowY: "auto" }} > */}

                {this.state.showPlaceholder && (
                    <div className='placeholder position-absolute ' style={{ zIndex: 0, top: this.props.hasPadding ? 7 : 0 }}>
                        <p >{translate("Text ...")}</p>
                    </div>
                )}
                {this.state.show && (

                    <div contentEditable={true} onDrop={this.handleOnDrop} onPaste={(e) => this.onPaste(e)} onDragStart={this.handleDragStart} onDragEnd={this.handleDragEnd} onSelect={this.getActiveStyle} id={this.props.id} onKeyDown={this.onKeyDown} ref={(el) => (this.editor = el)} onInput={this.handleInput} className="w-100  h-100 sc-gary " style={{ border: "none", outline: "none", position: "relative", zIndex: 0, minHeight: styleInfo?.minHeight, }} >
                        {/* onBlur={(e) => this.props.titleValue(e, this.editor)}  */}
                        {/* <span>&#8203;</span> */}
                        {/* {ReactHtmlParser(this.props.data)} */}
                        {/* <ResizableElement resizeArrows={this.resizeArrows}
                            sharedClassName={'resizer'}
                            sharedStyles={{}}
                            sideDistancePX = {-2}
                            activeClassName= {'noteBookImageCursorActive'}
                            >
                            <img src='/assets/icons/note/paperclip.svg' style={{ width: "100%", height: "100%" }} />
                        </ResizableElement> */}
                    </div>
                )}
                {/* </div> */}
            </div>
        );
    }
}
